// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"91":"person-record","127":"company-record","152":"eula","387":"project-record"}[chunkId] || chunkId) + "." + {"79":"2a303c6f4fd8b5ecbc4d","91":"71fd1051a8db5c6427f7","127":"bfa03bd7b55079ba514b","152":"40ab7d3924100ee8833d","387":"efdb0abd4819ae0e42f0"}[chunkId] + ".js";
};